import { Grid, Modal } from '@mui/material';
import { Box } from '@mui/system';
import React from 'react';



export const VideoModalTomHegna = (props) => {


    return (<Modal
        open={props.isOpen}
        onClose={props.closeModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
    >
        <Box style={{ width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <Grid
                style={{ flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start' }}
            >
                <div
                    className="watch-video-button-tom-hegna"
                    onClick={props.closeModal}
                >
                    <div className="text-button-watch-video-tom">
                        Close
                    </div>
                </div>
                <iframe
                    width="560"
                    height="315"
                    src="https://www.youtube.com/embed/G9tiZyYSuF0?autoplay=1&controls=0&rel=0"
                    title="Tom Hegna's Welcome Video"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen
                />
            </Grid>
        </Box>
    </Modal>)
}